import { IPickup } from '@/models/regions.model';
import { TCreatePickingFormValues } from './types';
import { SupportedLocales } from '@/models/localization.model';

export const getInitialPickupValues = (pickup?: IPickup | null): TCreatePickingFormValues => {
  if (!pickup) return {} as TCreatePickingFormValues;

  return {
    address: {
      latitude: pickup?.latitude ?? 0,
      longitude: pickup?.longitude ?? 0,
      locale: {
        [SupportedLocales.RU]: {
          name: pickup?.locale?.[SupportedLocales.RU]?.address,
        },
        [SupportedLocales.UK]: {
          name: pickup?.locale?.[SupportedLocales.UK]?.address,
        },
      },
      place_id: pickup?.external_id ?? '',
    },
    external_id: pickup?.external_id,
    is_active: pickup?.is_active,
    latitude: pickup?.latitude,
    longitude: pickup?.longitude,
    phone: pickup?.phone,
    region_id: pickup?.settlement?.region_id,
    settlement_id: pickup?.settlement?.id,
    is_default: pickup?.is_default,
    google_store_code: pickup?.google_store_code,
    schedule: {
      [SupportedLocales.UK]: {
        schedule: pickup?.locale?.[SupportedLocales.UK]?.working_hours,
      },
      [SupportedLocales.RU]: {
        schedule: pickup?.locale?.[SupportedLocales.RU]?.working_hours,
      },
    },
  };
};
